
export const ERROR_MESSAGES = {
  MUST_INPUT_CC: "Must input credit card information"
}